import React from 'react';
import styled from 'styled-components';
import { Container } from 'components/basics';
import { colors, textBold } from 'styles';
import Typography from '@material-ui/core/Typography/Typography';
import Button from 'components/basics/Button';
import { Link } from 'gatsby';
import { breakpoint } from 'src/utils/mediaQueries';
import { FormattedDate, FormattedMessage } from 'react-intl';

const ContentBlock = styled(Container)`
  border-radius: 20px;
  background-color: ${colors.shades.grey.light} !important;
  margin: 1.5em 0;
  width: 75%;
  flex-direction: row;
  max-height: 17em;
  ${breakpoint.down('sm')`
    flex-direction: column;
    max-height: 100vh;
    margin: 2em 0;
  `}
`;

const ThumbnailBlock = styled.div`
  height: 17em;
  width: 35%;
  background-image: url(${({ thumbnail }) => thumbnail});
  background-position: top;
  background-repeat: no-repeat;
  border-radius: 20px 0 0 20px;
  ${breakpoint.down('sm')`
    border-radius: 20px 20px 0 0;
    width: 100%;
  `}
`;

const TextBlock = styled.div`
  margin-left: 1em;
  width: 100%;
  padding: 1em;
`;

const DateBlock = styled(Typography)`
  font-size: 0.9em;
  color: ${colors.shades.grey.normal};
  ${textBold};
  margin: 0.5em 0 1em 0;
`;

const Title = styled(Typography)`
  ${textBold};
  font-size: ${props => props.theme.typography.body1.fontSize}px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active {
    color: ${colors.purple} !important;
    transition: all 0.2s ease-in-out;
  }
`;

const ReadButton = styled(Button)`
  float: right;
`;

const Paragraph = styled(Typography)`
  ${breakpoint.down('sm')`
    font-size: ${({ theme }) => theme.typography.fontSize}px;
  `}
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const UpdatedDate = styled.span`
  font-weight: normal;
  font-style: italic;
`;

const PostBlock = ({ data, lang }) => {
  return (
    <ContentBlock>
      <ThumbnailBlock thumbnail={data.thumbnail && data.thumbnail} />
      <TextBlock>
        <StyledLink to={`/${lang}/blog/${data.slug}`} state={{ lang }}>
          <Title variant="h2">{data.title}</Title>
        </StyledLink>
        <DateBlock>
          <FormattedMessage id="blog.publishedOn" />
          &nbsp;
          <FormattedDate
            value={data.createdAt}
            year="numeric"
            month="long"
            day="2-digit"
          />
          <UpdatedDate>
            &nbsp; - <FormattedMessage id="blog.updatedOn" />
            &nbsp;
            <FormattedDate
              value={data.updatedAt}
              year="numeric"
              month="long"
              day="2-digit"
            />
          </UpdatedDate>
        </DateBlock>
        <Paragraph
          dangerouslySetInnerHTML={{
            __html: `${data &&
              data.content.text
                .slice(0, 200)
                .split('\\n')
                .join(' ')}...`,
          }}
        />
        <Link to={`/${lang}/blog/${data.slug}`}>
          <ReadButton
            customBackgroundColor={colors.purple}
            customTextColor={colors.white}
            customHoverBackgroundColor={colors.shades.purple.dark}
            mt={2}
          >
            <FormattedMessage id="button.readArticle" />
          </ReadButton>
        </Link>
      </TextBlock>
    </ContentBlock>
  );
};

export default PostBlock;
